import React from 'react';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import { version } from '../../package.json'
const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(4),
  },
}));


export default function Copyright() {

  const classes = useStyles();
  return (
    <Typography variant="body2" color="textSecondary" align="center" className={classes.root}>
      {'Copyright © '}
      <Link color="inherit" href="https://sayweee.com/" target="_top">
        <u>Weee! Inc</u>
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
      <p>{'version '} {version}</p>
    </Typography>
  );
}
